import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.552 16.058a4.511 4.511 0 0 0 4.506 4.507 4.511 4.511 0 0 0 4.507-4.507 4.511 4.511 0 0 0-4.507-4.506 4.512 4.512 0 0 0-4.506 4.506Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.435 10.11a.198.198 0 0 0-.002-.199 12.132 12.132 0 0 0-4.32-4.282A12.05 12.05 0 0 0 16.058 4a12.006 12.006 0 0 0-9.426 4.54.197.197 0 0 0-.017.221l3.394 5.88a.198.198 0 0 0 .363-.05 5.871 5.871 0 0 1 6.213-4.381h9.678a.198.198 0 0 0 .172-.1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.84 21.786a.197.197 0 0 0-.21-.07 5.86 5.86 0 0 1-1.572.215 5.902 5.902 0 0 1-5.325-3.399l-4.842-8.386a.198.198 0 0 0-.343.002 12.065 12.065 0 0 0 1.404 13.816 12.056 12.056 0 0 0 7.337 4.022c.07 0 .135-.037.17-.099l3.396-5.88a.198.198 0 0 0-.015-.221Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.103 11.527h-6.798a.198.198 0 0 0-.138.34 5.826 5.826 0 0 1 1.764 4.19 5.83 5.83 0 0 1-1.058 3.359l-4.85 8.401a.198.198 0 0 0 .17.297h.003a11.985 11.985 0 0 0 8.434-3.576 11.983 11.983 0 0 0 3.487-8.481 12 12 0 0 0-.83-4.404.198.198 0 0 0-.184-.126Z",
    fill: "currentColor"
  }));
};

var SvgChrome = styled(SvgComponent).withConfig({
  displayName: "Chrome__SvgChrome",
  componentId: "sc-17ua2tp-0"
})(["", " ", ""], size, color);
export default SvgChrome;